/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-07-24 19:15:40
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-08-15 14:34:03
 * @FilePath: \mpc-2\features\mpc-common\src\utils\datracker.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { $sType } from "@mpc/common/src/utils/sType";

export const isDevOrTest = () => {
  const hostName = window.location.hostname;
  return $sType === 'inner' ? hostName !== 'mpc.pm.netease.com' : hostName !== 'mpc.netease.com' ;
};

const APP_KEY_MAP = {
  inner: {
    dev: '9d4bedeb9394888aa4f2b35a6e13b48edcfc7d12',
    prod: 'b99a2129098abc91658be21be775dd2a1648578a',
  },
  outer: {
    dev: '5918d18111528d861d2cc14f86c58d5b87d47bc8',
    prod: '5a2fbb632cac656ae8913f2135ee18fdbe8b0e56',
  },
}
const getAppKey = () => {
  if ($sType === 'inner') {
    return isDevOrTest() ? APP_KEY_MAP.inner.dev : APP_KEY_MAP.inner.prod 
  }
  return isDevOrTest() ? APP_KEY_MAP.outer.dev : APP_KEY_MAP.outer.prod 
}

export const dainit = () => {
  if (!window.DATracker || !window.DATracker.init) {
    return;
  }

  const appKey = getAppKey();

  window.DATracker.init(appKey, {
    truncateLength: 255,
    persistence: 'localStorage',
    cross_subdomain_cookie: false,
  });
};

export const daLogin = (userId: string) => {
  if (!window.DATracker || !window.DATracker.login) {
    return;
  }
  window.DATracker.login(userId);
}

export const datrack = (eventId: string, attributes?: object) => {
  if (!window.DATracker || !window.DATracker.track) {
    return;
  }

  window.DATracker?.track?.(eventId, attributes);
};
